import { Link } from "react-router-dom";
import { Leaf, Phone } from "lucide-react";
import { CONTACT } from "@/data/cabanas";

export const Header = () => {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F6F0]/85 border-b border-[#E3DCD2]/60"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="logo-link"
          className="flex items-center gap-3 group"
        >
          <span className="w-10 h-10 flex items-center justify-center bg-[#2C5545] text-[#F9F6F0] group-hover:bg-[#1E3B30] transition-colors">
            <Leaf size={20} strokeWidth={1.5} />
          </span>
          <span className="flex flex-col leading-tight">
            <span className="text-[10px] tracking-[0.25em] uppercase text-[#5C6661]">
              Hospedagem rural
            </span>
            <span className="text-lg font-bold tracking-tight text-[#1A2421]">
              Cabanas da Quinta
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a
            href="/#cabanas"
            data-testid="nav-cabanas"
            className="text-[#1A2421] hover:text-[#2C5545] transition-colors"
          >
            Cabanas
          </a>
          <a
            href="/#experiencia"
            data-testid="nav-experiencia"
            className="text-[#1A2421] hover:text-[#2C5545] transition-colors"
          >
            Experiência
          </a>
          <a
            href="/#faq"
            data-testid="nav-faq"
            className="text-[#1A2421] hover:text-[#2C5545] transition-colors"
          >
            Perguntas
          </a>
          <a
            href="/#contato"
            data-testid="nav-contato"
            className="text-[#1A2421] hover:text-[#2C5545] transition-colors"
          >
            Contato
          </a>
        </nav>

        <a
          href={`https://wa.me/${CONTACT.phoneIntl.replace("+", "")}`}
          target="_blank"
          rel="noreferrer"
          data-testid="header-whatsapp"
          className="hidden sm:flex items-center gap-2 px-5 h-11 bg-[#2C5545] text-[#F9F6F0] text-sm font-bold hover:bg-[#1E3B30] transition-colors"
        >
          <Phone size={16} strokeWidth={1.8} />
          {CONTACT.phone}
        </a>
      </div>
    </header>
  );
};

export default Header;
